import { apiService } from './apiService';

export const portalService = {
  getCurrentStudent: userId => apiService.get(`students/user/${userId}`),
  getCurrentTeacher: userId => apiService.get(`teachers/user/${userId}`),
  getParentDashboard: () => apiService.get('dashboard'),
  getStudentClasses: classIds =>
    Promise.all((classIds || []).map(classId => apiService.getById('classes', classId))),
};
